angular.module("qcc.components", []).component("qcc", {
  templateUrl: "ng/components/qcc/qcc.html",
  bindings: {
    getDocList: "&?",
    questionario: "=",
    dropdown: "=",
    getTodaysDate: "&?",
    validationObj: "=",
    resizeTable: "&?",
    formaGiuridica: "=",
    onCatSelected: "&?",
    instantModel: "<"
  },
  controllerAs: "qccCtrl",
  controller: function qccController(
    $giuridicVersion,
    $typeDomainService,
    $q,
    $configService
  ) {
    var self = this;
    self.$giuridicVersion = $giuridicVersion;

    self.initialized = false;

    self.$onInit = function () {
      self.dropdown = {
        listaCategorieDisponibili: []
      };

      self.questionario = {
        categoria: ""
      };

      /**
       * True if category already selected
       */
      var categorySelected = !!self.instantModel.financialCustomer.metadata.categoria &&
        !!self.instantModel.financialCustomer.metadata.categoria != "";

      /**
       * Initialized as the category, might be null or undefined if categorySelected is not true
       */
      var category = self.instantModel.financialCustomer.metadata.categoria;

      if (categorySelected) {
        self.questionario.categoria = category;
        self.onCatSelected({
          value: category
        });
      }

      fetchCategoryList()
        .then(function (categories) {
          self.dropdown.listaCategorieDisponibili = categories;

          //Se ne torna una sola prevalorizzo quella e disabilito
          if (self.dropdown.listaCategorieDisponibili.length === 1) {
            self.questionario.categoria = self.dropdown.listaCategorieDisponibili[0];
            self.disabled = true;
          }

          //Aggiorno il modello
          self.onCatSelected({
            value: self.questionario.categoria
          });
        })

    };

    self.onChange = function (value) {
      self.onCatSelected({
        value: value
      });
    };

    var fetchCategoryList = function () {
      self.loading = true;
      return $q(function (resolve, reject) {
        $typeDomainService
          .getDomainSet("RI_DROPDOWN_DOMAINS", "CATEGORY")
          .then(function (res) {
            var formaGiuridica = self.instantModel.financialCustomer.metadata.riUserG.formaGiuridica;
            var cciaa = self.instantModel.financialCustomer.metadata.riUserG.cciaa;
            //Filtro le categorie disponibili in base alla forma giuridica
            var categories = res.domainList
              .filter(function (el) {
                return el.description.split('|').indexOf(formaGiuridica) != -1;
              })
              .map(function (elem) {
                return elem.value;
              });

            /*controllo la forma giuridica e la cciaa per assegnare le corrette categorie
              nel caso forma giuridica è IND e cciaa valorizzata la categoria disponibile è solo Altre
              nel caso forma giuridica è IND e cciaa no valorizzata le categorie disponibili sono tutte ad eccezione di altre
              */
            if ($giuridicVersion.checkIfInd(formaGiuridica) && cciaa) {
              categories = [];
              categories.push($configService.getProperty('CAT_ALTRO'));
            } else if ($giuridicVersion.checkIfInd(formaGiuridica) && !cciaa) {
              categories = categories
                .filter(function (cat) {
                  return cat != $configService.getProperty('CAT_ALTRO');
                });
            }
            return resolve(categories);

          })
          .catch(function (err) {
            console.log(err);
          })
          .finally(function () {
            self.loading = false;
          });
      });
    };
  }
});